export default (value: unknown): value is FileList => value instanceof FileList;
